"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChathostService = void 0;
class ChathostService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Chathost Reg State
     * @returns RegisterStepsResponseModel Successful Response
     * @throws ApiError
     */
    chathostChathostRegState() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/regwizard/steps',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Chathost New Register
     * @param requestBody
     * @param ran
     * @param ranVisitor
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostChathostNewRegister(requestBody, ran, ranVisitor) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/regwizard/new',
            cookies: {
                'Ran': ran,
                'RanVisitor': ranVisitor,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Logon
     * @param requestBody
     * @returns ChathostLogonResponseModel Successful Response
     * @throws ApiError
     */
    chathostLogon(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/logon',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Events
     * @returns EventResponse Successful Response
     * @throws ApiError
     */
    chathostGetEvents() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/events',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Refresh Token
     * @returns TokenRefreshResponseModel Successful Response
     * @throws ApiError
     */
    chathostRefreshToken() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/session/refresh/token',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Logoff
     * @returns LogoffResponseModel Successful Response
     * @throws ApiError
     */
    chathostLogoff() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/session/logoff',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Validation Error`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Chathost Resources
     * @returns ResourcesResponseModel Successful Response
     * @throws ApiError
     */
    chathostChathostResources() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/resources/',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Chathost Agreement List
     * @returns AgreementResponseList Successful Response
     * @throws ApiError
     */
    chathostChathostAgreementList() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/agreement/list',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Chathost Agreement Get
     * @param id
     * @returns AgreementResponse Successful Response
     * @throws ApiError
     */
    chathostChathostAgreementGet(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/agreement/promotion',
            query: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chathost Agreement Post
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostChathostAgreementPost(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/agreement/promotion',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chathost Promotion Agreement Available Get
     * @returns AgreementAvailableResponse Successful Response
     * @throws ApiError
     */
    chathostChathostPromotionAgreementAvailableGet() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/agreement/promotion/available',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Chathost Consent Status
     * @returns ConsentResponse Successful Response
     * @throws ApiError
     */
    chathostChathostConsentStatus() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/agreement/consent',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Chathost Consent
     * @param individualId
     * @param formData
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostChathostConsent(individualId, formData) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/agreement/consent/{individual_id}',
            path: {
                'individual_id': individualId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chathost Consent Download
     * @param requestBody
     * @returns FileDownloadDetails Successful Response
     * @throws ApiError
     */
    chathostChathostConsentDownload(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/agreement/consent/download/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chathost Age Verification Start
     * @param individualProfileId
     * @param requestBody
     * @returns ExternalAgeVerifictionResponse Successful Response
     * @throws ApiError
     */
    chathostChathostAgeVerificationStart(individualProfileId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/ageverification/start/{individual_profile_id}',
            path: {
                'individual_profile_id': individualProfileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chathost Age Verification Resend
     * @param individualId
     * @param requestBody
     * @returns ExternalAgeVerifictionResponse Successful Response
     * @throws ApiError
     */
    chathostChathostAgeVerificationResend(individualId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/ageverification/resend/{individual_id}',
            path: {
                'individual_id': individualId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chathost Age Verification Status
     * @returns ChathostAVStatus Successful Response
     * @throws ApiError
     */
    chathostChathostAgeVerificationStatus() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/ageverification/status',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Spot Prizes Winners
     * @returns SpotPrizesResponse Successful Response
     * @throws ApiError
     */
    chathostSpotPrizesWinners() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/promo/luckychats',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Anniversary
     * @returns AnniversaryResponse Successful Response
     * @throws ApiError
     */
    chathostAnniversary() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/promo/anniversary',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Valentines
     * @returns ValentinesResponse Successful Response
     * @throws ApiError
     */
    chathostValentines() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/promo/valentines',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Valentines Join Update
     * @param requestBody
     * @returns ValentinesJoinUpdateResponse Successful Response
     * @throws ApiError
     */
    chathostValentinesJoinUpdate(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/promo/valentines',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Profile Img
     * Empty function, but we need to export the constants
     * @param img
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostProfileImg(img) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/images/',
            query: {
                'img': img,
            },
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Info
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostInfo() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/kyc/info',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Upsert
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostUpsert(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/kyc/upsert',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Classifiers Get
     * @param requestBody
     * @returns ClassifiersGetResponse Successful Response
     * @throws ApiError
     */
    chathostClassifiersGet(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/classifiers/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chathost Revenue Details
     * @returns ChathostRevenueDetails Successful Response
     * @throws ApiError
     */
    chathostGetChathostRevenueDetails() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/revenuedetails/info',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get Chathost List Payments
     * @returns ChathostPayment Successful Response
     * @throws ApiError
     */
    chathostGetChathostListPayments() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/revenuedetails/listpayments',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get Chathost Payment Details
     * @param requestBody
     * @returns PaymentDetailsResponse Successful Response
     * @throws ApiError
     */
    chathostGetChathostPaymentDetails(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/revenuedetails/paymentdetails',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chathost Payment Detail Update
     * @returns PaymentDetails Successful Response
     * @throws ApiError
     */
    chathostGetChathostPaymentDetailUpdate() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/revenuedetails/paymentdetailsupdate',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update Chathost Payment Detail
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostUpdateChathostPaymentDetail(requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/chathost/revenuedetails/paymentdetailsupdate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Chathost Payment Detail
     * @param requestBody
     * @returns PaymentDetailsCreateResponse Successful Response
     * @throws ApiError
     */
    chathostCreateChathostPaymentDetail(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/revenuedetails/paymentdetailsupdate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Chathost Payment Confirm Email Address
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostUpdateChathostPaymentConfirmEmailAddress(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/chathost/revenuedetails/paymentdetailsupdate/confirmemailaddress',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Chathost Payment Resend Confirmation Email Address
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostUpdateChathostPaymentResendConfirmationEmailAddress() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/revenuedetails/paymentdetailsupdate/resendconfirmationemailaddress',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update Chathost Payment Resend Confirmation Email Link
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostUpdateChathostPaymentResendConfirmationEmailLink() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/revenuedetails/paymentdetailsupdate/resendconfirmationemaillink',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
exports.ChathostService = ChathostService;
